import React, { useState, useEffect } from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import { change, getFormValues } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';

import { fieldsRenderer } from '@Utils/document-upload/document-upload';
import { AppDispatch, IStore } from '../../../../store.type';
import { FORMNAME_RFI } from '@Utils/constants';
import { AddressButtonContainer, ProvideAddressHeading } from '../styles';
import { getCountryCode, getSgkycFlowRfiData } from '@Redux/selectors';
import { SG_ODD_FLOW_TYPES } from '../ScreenConstants';
import { getAddressData } from '../../../bene-additional-info/utils/utils';
import { ADDRESS_PAGE, changeFormField, populateFormWithAddressData } from '../utils';
import { CommonButton } from '@Components';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import { setFlowType, setJumioAvailability } from '@Redux/actions/rfi/rfi-action';
import { isJumioServiceAvailable } from '@Redux/actions/individual-user-flow/individual-user-flow-action';
import { DocumentOption, NestedField, RadioOptionValue } from '../types';

const AddressPage: React.FC = () => {
  const countryCode = useSelector(getCountryCode);
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const personalInfoNestedFieldsJson = sgKycFlowData?.renderingObject?.values?.find(
    (item: DocumentOption) => item.code === 'MANUAL'
  )?.nested_fields_json;
  const permanentSgResidentValues = personalInfoNestedFieldsJson?.find(
    (item: NestedField) => item.name === 'is_permanent_sg_resident'
  )?.values;
  const actualPermanentSgResident =
    permanentSgResidentValues?.find((item: RadioOptionValue) => item.label === 'Yes')?.values || [];
  const jumioValues = actualPermanentSgResident?.find(
    (item: DocumentOption) => item.code === 'JUMIO'
  );
  const radioFieldName = sgKycFlowData?.rfiDetails?.fields_json?.[0]?.field_name || '';
  const nestedFieldsJson = sgKycFlowData?.nestedFieldsJson || [];
  const selectedFlowType = sgKycFlowData?.selectedFlowType;
  const getAllformVal = useSelector((state: IStore) => getFormValues(FORMNAME_RFI)(state) || {});
  const dispatch = useDispatch<AppDispatch>();
  const { heading, buttonText } = ADDRESS_PAGE;
  const [disableForm, setDisableForm] = useState(false);
  const isSingpassFlow = selectedFlowType === SG_ODD_FLOW_TYPES.SINGPASS;

  const checkIfJumioServiceAvailable = async () => {
    dispatch(activateLoader());
    const isJumioAvailable = await dispatch(isJumioServiceAvailable(countryCode));
    if (isJumioAvailable && jumioValues?.flow_start) {
      dispatch(setJumioAvailability(true));
      dispatch(setFlowType(SG_ODD_FLOW_TYPES.JUMIO));
      changeFormField(radioFieldName, 'flow_type', SG_ODD_FLOW_TYPES.JUMIO, dispatch);
    } else dispatch(setJumioAvailability(false));
    dispatch(disableLoader());
  };

  useEffect(() => {
    if (isSingpassFlow) {
      dispatch(activateLoader());
      const fetchAddressData = async () => {
        const response = await dispatch(getAddressData());
        if (response) {
          const allFieldsHaveValue = populateFormWithAddressData(
            response,
            nestedFieldsJson,
            FORMNAME_RFI,
            dispatch
          );
          setDisableForm(allFieldsHaveValue);
        }
        dispatch(disableLoader());
      };
      fetchAddressData();
    } else if (
      selectedFlowType === SG_ODD_FLOW_TYPES.NRIC ||
      selectedFlowType === SG_ODD_FLOW_TYPES.NRIC_PR
    ) {
      checkIfJumioServiceAvailable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFlowType]);

  const submitAddressDetails = async () => {
    // Event Propagation to main rfi submit form
  };

  return (
    <>
      <Grid.Row className="no-padding1">
        <ProvideAddressHeading>{heading}</ProvideAddressHeading>
        <Grid className="grid-relative upload-doc-section-grid">
          <Grid.Row className="row-3 space-between">
            {fieldsRenderer(
              nestedFieldsJson,
              isSingpassFlow ? disableForm : false,
              getAllformVal,
              {
                dispatch,
                change,
                FORMNAME_RFI
              },
              null,
              true
            )}
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <AddressButtonContainer>
        <CommonButton text={buttonText} onClick={submitAddressDetails} />
      </AddressButtonContainer>
    </>
  );
};

export default AddressPage;
